import { render } from "./batchSendSz.vue?vue&type=template&id=b90aac2a&scoped=true"
import script from "./batchSendSz.vue?vue&type=script&lang=js"
export * from "./batchSendSz.vue?vue&type=script&lang=js"

import "./batchSendSz.vue?vue&type=style&index=0&id=b90aac2a&lang=less&scoped=true"
import "./batchSendSz.vue?vue&type=style&index=1&id=b90aac2a&lang=scss"
import "./batchSendSz.vue?vue&type=style&index=2&id=b90aac2a&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b90aac2a"]])

export default __exports__